import React from "react"
import { TextareaAutosize } from "@mui/material"

const FormikTextArea = ({
    field,
    ...props
}) => <TextareaAutosize {...field} {...props} />

export default FormikTextArea